import React from 'react';
import '../css/newsEvents.css';
import truncateWords from '../../../../format/truncateWords';

const NewsEvents = ({ news }) => {
  return (
    <section className="media-talking-about-us">
      <div className="container">
        <h2 className="text-center default-box-title">TIN TỨC & Sự kiện</h2>
        {news.map((content, idx) => (
          <div key={idx}>
            <h3 className="default-box-title">Về {content.title}</h3>
            <div className="bg-layer my-md-5 my-4 px-xl-4 px-3">
              <div className="box-wrap">
                <div className="items">
                  {content.data.map((item, index) => (
                    <div
                      key={index}
                      className="item-wrap bg-white shadow-sm p-3"
                    >
                      <div className="text-center mb-3">
                        <a
                          href={`${content.slug}/${item.slug}`}
                          title={item.title}
                        >
                          <img
                            data-src={item.thumbnail}
                            className=" thumbnail owl-lazy"
                            alt={item.title}
                            loading="lazy"
                            src={item.thumbnail}
                            style={{
                              width: '100%',
                              height: '200px',
                              objectFit: 'cover',
                              opacity: '1',
                            }}
                          />
                        </a>
                      </div>
                      <div className="row">
                        <h3 className="mb-3">
                          <a
                            href={`${content.slug}/${item.slug}`}
                            title={item.title}
                          >
                            {truncateWords(item.title, 14)}
                          </a>
                        </h3>
                        <p>{truncateWords(item.short_description, 20)}</p>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="text-center more">
                  <a
                    href={`${content.slug ? content.slug : '#'}?page=1`}
                    title=""
                    className="btn"
                  >
                    <img
                      src="/images/icons/list-icon-white.png"
                      className="mw-100 me-2"
                      alt=""
                      loading="lazy"
                    />
                    Xem tất cả
                  </a>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default NewsEvents;
